module.exports = __webpack_public_path__ + "media/8.c4c25d44.mp3";